import axios from "axios";

export const searchAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/search/`,
  timeout: 10000,
});
